import { RESERVATION_FEE_RATE, TAX_RATE } from '@/config/constants'

/**
 * Pure money math shared across BOTH commerce domains (appointments and
 * orders/cart). Deliberately import-free beyond config constants so client
 * bundles can consume it directly: appointment-breakdown.ts re-exports these
 * for the server-side pricing paths, and computeCartSummary
 * (src/lib/utils/price-resolution.ts) imports them for the cart, retiring the
 * converged-by-contract duplication. Do NOT add server-only imports here
 * (@/lib/db, next/*, estimator) — that is what appointment-breakdown.ts is for.
 */

export const round2 = (n: number) => Math.round(n * 100) / 100

/**
 * Customer-facing breakdown from a pre-tax subtotal:
 * subtotal -> tax -> grand total -> down payment (reservation fee) -> balance due.
 * `taxOverride` lets a locked snapshot supply its own captured tax.
 */
export function buildBreakdown(subtotal: number, taxOverride?: number) {
  const s = round2(subtotal)
  const tax = round2(taxOverride ?? s * TAX_RATE)
  const grandTotal = round2(s + tax)
  const reservationFee = round2(grandTotal * RESERVATION_FEE_RATE)
  const balanceDue = round2(grandTotal - reservationFee)
  return { subtotal: s, tax, grandTotal, reservationFee, balanceDue }
}
